export default {
  listItemTitleColor: Styles.color.black,
  listItemSubtextColor: Styles.color.black,
};
